import client from "./client";

export const listBanks = async () => {
  return await client({
    url: "/banks",
    method: "get",
  });
};

export const getRecentAccount = async (purchasePk) => {
  return await client({
    url: `/accounts?purchasepk=${purchasePk}`,
    method: "get",
  });
};
